import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setTrips } from "../../store/allTripsSlice";
import "./Home.css";
import Footer from "../../components/footer/Footer";
import TripCard from "../../components/trip-cards/TripCard";
import { Box, IconButton } from "@mui/material";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import CreateTripButton from "../../components/create-trip-btn/CreateTripButton";
import HomeNav from "../../components/navbar/home-nav/HomeNav";

const Home = () => {
  const dispatch = useDispatch();
  const trips = useSelector((state) => state.allTrips.trips);

  const [visibleTrips, setVisibleTrips] = useState(Array.isArray(trips) ? trips : []);

  const abbreviateDestination = (destination) => {
    if (destination && destination.includes(",")) {
      return destination.split(",")[0];
    }
    return destination;
  };

  const handleDelete = (tripId) => {
    setVisibleTrips((prevTrips) =>
      prevTrips.filter((trip) => trip.TRIP_ID !== tripId)
    );
  };

  useEffect(() => {
    fetch("https://tripmate-rbck.onrender.com/trips")
      .then((res) => res.json())
      .then((data) => {
        console.log("Fetched trips:", data);
        dispatch(setTrips(data));
        if (Array.isArray(data)) {
          setVisibleTrips(data);
        } else {
          setVisibleTrips([]);
        }
      })
      .catch((err) => console.error("Error fetching trips:", err));
  }, [dispatch]);

  const scrollRef = useRef();

  const scroll = (offset) => {
    scrollRef.current.scrollBy({ left: offset, behavior: "smooth" });
  };

  const [showArrows, setShowArrows] = useState(false);

  useEffect(() => {
    const checkOverflow = () => {
      const scrollEl = scrollRef.current;
      if (scrollEl && scrollEl.scrollWidth > scrollEl.clientWidth) {
        setShowArrows(true);
      } else {
        setShowArrows(false);
      }
    };

    checkOverflow();

    window.addEventListener("resize", checkOverflow);

    return () => window.removeEventListener("resize", checkOverflow);
  }, [visibleTrips]);

  return (
    <div className="home-page">
      <HomeNav />
      <div className="home-header">
        <div className="home-title-banner">
          <h1>Tripmate</h1>
        </div>

        <CreateTripButton />
        <div className="tripcard-subtitle">
          <h2>My Trips</h2>
        </div>
        <Box
          sx={{
            width: "100%",
            overflow: "hidden",
            position: "relative",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            paddingLeft: "140px",
          }}
        >
          {showArrows && (
            <IconButton
              onClick={() => scroll(-300)}
              sx={{
                position: "relative",
                top: "-50px",
              }}
            >
              <ChevronLeft />
            </IconButton>
          )}
          <Box
            ref={scrollRef}
            sx={{
              display: "flex",
              overflowX: "auto",
              scrollBehavior: "smooth",
              gap: 5,
              px: 1,
              py: 1,
              maxWidth: "100%",
              scrollSnapTrype: "x mandatory",
            }}
          >
            {visibleTrips.map((trip) => (
              <Box
                key={trip.TRIP_ID}
                sx={{ minWidth: 280, scrollSnapAlign: "start" }}
              >
                <TripCard trip={trip} onDelete={handleDelete} abbreviateDestination={abbreviateDestination(trip.DESTINATION)} />
              </Box>
            ))}
          </Box>
          {showArrows && (
            <IconButton
              onClick={() => scroll(300)}
              sx={{
                position: "relative",
                top: "-50px",
              }}
            >
              <ChevronRight />
            </IconButton>
          )}
        </Box>
      </div>
      <Footer />
    </div>
  );
}

export default Home;
